import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import EllipseFill from '../../../svg/ellipse_fill.svg';
import EllipseSrtoke from '../../../svg/ellipse_stroke.svg';

gsap.registerPlugin(ScrollTrigger);

const Ticker = ({ tickers }) => {
  const tickerRef = useRef(null);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const ticker = tickerRef.current;
    const lines = ticker.querySelectorAll('.ticker-line');
    
    let scrollDirection = 'right';
    let currentX = 0;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      scrollDirection = currentScrollY > lastScrollY.current ? 'right' : 'left';
      lastScrollY.current = currentScrollY;

      lines.forEach((line, index) => {
        const speed = 3 - (index * 0.1);
        const direction = scrollDirection === 'right' ? 1 : -1;
        
        gsap.to(line, {
          x: `+=${direction * speed}`,
          duration: 0.1,
          ease: 'none'
        });
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="ticker" ref={tickerRef}>
      <div className="ticker-wrapper">
        <div className="ticker-line ticker-line__top">
          {tickers.map((item, index) => {
            return (
              <div className="ticker-line__item" key={index}>
                <span className="ticker-line__title ticker-line__title-top">
                  {item}
                </span>
                <span className="ticker-line__ellipse-wrapper">
                  <EllipseFill className="ticker-line__ellipse ticker-line__ellipse-top" />
                </span>
              </div>
            );
          })}
        </div>

        <div className="ticker-line ticker-line__middle">
          {tickers.map((item, index) => {
            return (
              <div className="ticker-line__item" key={index}>
                <span className="ticker-line__title ticker-line__title-middle">
                  {item}
                </span>
                <span className="ticker-line__ellipse-wrapper">
                  <EllipseSrtoke className="ticker-line__ellipse ticker-line__ellipse-middle" />
                </span>
              </div>
            );
          })}
        </div>

        <div className="ticker-line ticker-line__bottom">
          {tickers.map((item, index) => {
            return (
              <div className="ticker-line__item" key={index}>
                <span className="ticker-line__title ticker-line__title-bottom">
                  {item}
                </span>
                <span className="ticker-line__ellipse-wrapper">
                  <EllipseSrtoke className="ticker-line__ellipse ticker-line__ellipse-bottom" />
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

Ticker.propTypes = {
  tickers: PropTypes.array,
};

export default Ticker;
